const chartGranularity = {
  HOURS: 'hours',
  DAY: 'day',
  MONTH: 'month',
};

// eslint-disable-next-line import/prefer-default-export
export { chartGranularity };
